import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	rovoChatButtonLabel: {
		id: 'conversation-assistant-button.ask-rovo-label',
		defaultMessage: 'Ask Rovo',
		description: 'Label for the button that opens the conversation assistant',
	},
});
